import { GET_DETAIL, LIST, LIST_BY_CATEGORY, LIST_POPULAR, LOAD_RELATED, LIST_SERVICE_OF_THE_MONTH } from './types';

export function getDetail(jobTypeId = '', format?: string) {
  return {
    payload: {
      format,
      jobTypeId,
    },
    type: GET_DETAIL,
  };
}

export function list({ proSignUp = false }: { proSignUp?: boolean } = {}) {
  return {
    payload: {
      proSignUp,
    },
    type: LIST,
  };
}

export function listByCategoryId(id: string) {
  return {
    payload: {
      id,
    },
    type: LIST_BY_CATEGORY,
  };
}

export function listPopular({
  cityKey,
  prefectureKey,
  categoryId,
}: { categoryId?: string; cityKey?: string; prefectureKey?: string } = {}) {
  return {
    payload: {
      categoryId,
      cityKey,
      prefectureKey,
    },
    type: LIST_POPULAR,
  };
}

export function loadRelated({
  jobTypeId = '',
  prefectureId,
  requestableOnly = false,
}: {
  jobTypeId?: string;
  prefectureId?: string;
  requestableOnly?: boolean;
}) {
  return {
    payload: {
      id: jobTypeId,
      prefectureId,
      requestableOnly,
    },
    type: LOAD_RELATED,
  };
}

export function listServiceOfTheMonth() {
  return {
    type: LIST_SERVICE_OF_THE_MONTH,
  };
}
